$(document).ready(function () {
    // Product Page Functionality
    if ($('.template-product').length) {
        let _addToCartForms = $('.template-product').find('form[action="/cart/add"]');
        if (_addToCartForms.length) {
            _addToCartForms.each(function (_index, _form) {
                $(_form).on('submit', function (event) {
                    addAddRechargeToCartListener(event);
                });
            })
        }
    }

    // Replenish Refill Page Functionality
    if ($('.page-replenish-amp-refill').length) {
        let _addToCartForms = $('.page-replenish-amp-refill').find('form[action="/cart/add"]');
        if (_addToCartForms.length) {
            _addToCartForms.each(function (_index, _form) {
                $(_form).on('submit', function (event) {
                    let _formData = $(this).serializeArray();
                    let _productDivBlock = $(_form).parent();
                    if (_productDivBlock.hasClass('shg-product')) {
                        let productInitHandler = _productDivBlock.attr('id');
                        for (const _shgProduct of __shgProductInits) {
                            if (_shgProduct.uuid === productInitHandler) {
                                if (__shgRefillProductsData[_shgProduct.productHandle] !== undefined) {
                                    let _shProduct = __shgRefillProductsData[_shgProduct.productHandle];

                                    let _currentVariantId = _formData[0].value;

                                    let _productVariants = _shProduct.variants;
                                    for (const _variant of _productVariants) {
                                        if (_variant.id === _currentVariantId && _variant.name.includes('Replenish')) {
                                            event.preventDefault();
                                            if (_shProduct.selling_plan_groups.length && _shProduct.selling_plan_groups[0].selling_plans[0] !== undefined) {
                                                let _sellingPlan = _shProduct.selling_plan_groups[0].selling_plans[0];
                                                data = {
                                                    "id": _currentVariantId,
                                                    "quantity": 1,
                                                    "selling_plan": _sellingPlan.id
                                                }
                                                jQuery.ajax({
                                                    type: 'POST',
                                                    url: '/cart/add.js',
                                                    data: data,
                                                    dataType: 'json',
                                                    success: function () {
                                                        window.location.href = '/cart';
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            })
        }
    }

});


function addAddRechargeToCartListener(event) {

    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let _currentVariant = urlParams.get('variant');

    let _metaData = window.ShopifyAnalytics.meta;
    let _productID = _metaData.product.id;

    if (_currentVariant == null) {
        let shProductData = getProductShData(_productID);
        _currentVariant = shProductData.initialVariant.id;
    }

    let _productVariants = _metaData.product.variants;
    for (const _variant of _productVariants) {
        if (_variant.id == _currentVariant && _variant.name.includes('Replenish')) {
            event.preventDefault();
            addRechargeItemToCart(_variant.id, _productID, 1);
        }
    }
}

function addRechargeItemToCart(variant_id, parent_id, qty) {
    let _shProduct = getProductShData(parent_id);
    if (_shProduct != null) {
        if (_shProduct.selling_plan_groups.length && _shProduct.selling_plan_groups[0].selling_plans[0] !== undefined) {
            let _sellingPlan = _shProduct.selling_plan_groups[0].selling_plans[0];
            let data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": _sellingPlan.id
            }
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function () {
                    window.location.href = '/cart';
                }
            });
        }
    }
    //window.location = '/checkout';
}

function getProductShData(product_id) {
    let _products = __shgProducts;
    for (let _slug in _products) {
        let _shProduct = _products[_slug];
        if (_shProduct.id === product_id) {
            return _shProduct;
        }
    }
    return null;
}